import { MdOutlineDashboard, MdHome, MdOutlineExitToApp } from "react-icons/md";
import { BsCurrencyRupee, BsPersonCheck, BsPersonPlus, BsFillPersonFill, BsPersonCheckFill } from "react-icons/bs";
import { TbLogout, TbSettingsPlus, TbUsers } from "react-icons/tb";
import { IoDocumentTextOutline } from "react-icons/io5";
export const lendingDashboardSideMenu = [
  { id: 1, title: "HOME", path: "/", icon: <MdHome /> },
  { id: 2, title: "Dashboard", path: "/hrtools", icon: <MdOutlineDashboard /> },
  { id: 3, title: "Profile", path: "/hrtools/employee-profile", icon: <BsFillPersonFill /> },
  // { id: 4, title: "Employee", path: "/", icon: <MdPeopleOutline /> },
  // { id: 5, title: "Organisation", path: "/", icon: <GiOrganigram /> },
  // { id: 6, title: "Department", path: "/", icon: <HiOutlineOfficeBuilding /> },
  { id: 7, title: "Attendance", path: "/hrtools/attendance/attendance-report", icon: <BsPersonCheck /> },
  { id: 8, title: "Leave", path: "/hrtools/attendance-tracking/leave-request", icon: <TbLogout /> },
  // { id: 9, title: "Project", path: "/", icon: <GoProjectRoadmap /> },
  // { id: 10, title: "Payroll", path: "/", icon: <BsCash /> },
  // { id: 11, title: "Notice", path: "/", icon: <HiDocumentText /> },
  // { id: 12, title: "Settings", path: "/", icon: <IoSettings /> },
];

export const dashboardSideMenu = [
  {
    id: 1,
    title: "Candidate Onboarding",
    path: "/hrtools/employee-onboarding/",
    icon: <BsPersonPlus />,
  },
  { id: 2, title: "Generate Documents", path: "/hrtools/generate-documents", icon: <IoDocumentTextOutline /> },
  { id: 3, title: "Employee Profile", path: "/hrtools/employee-profile", icon: <TbUsers /> },
  {
    id: 4,
    title: "Attendance Tracking",
    subLinks: [
      { id: 1, title: "Mark Attendance", link: "/hrtools/attendance/attendance-markup", icon: <BsPersonCheck /> },
      { id: 2, title: " Attendance Report", link: "/hrtools/attendance/attendance-report" },
      { id: 3, title: "Leave Request", link: "/hrtools/attendance-tracking/leave-request" },
      { id: 4, title: "Holiday Calendar", link: "/hrtools/attendance/holiday-calendar" },
      // { id: 1, title: "Leave Report", link: "" },
    ],
    path: "/hrtools/attendance-dashboard",
    icon: <BsPersonCheck />,
  },
  {
    id: 5,
    title: "Manage Fund",
    subLinks: [
      { id: 1, title: "Pay Roll", link: "/hrtools/manage-fund/payroll" },
      { id: 1, title: " Advance Salary", link: "/hrtools/manage-fund/advance-salary" },
    ],
    path: "/hrtools/manage-fund",
    icon: <BsCurrencyRupee />,
  },
  {
    id: 6,
    title: "Assets Management",
    subLinks: [
      { id: 1, title: "Add Asset", link: "/hrtools/assets-management/add-asset" },
      { id: 2, title: "Pending Asset Verification", link: "/hrtools/assets-management/pending-asset-verification" },
      { id: 3, title: "Inventory", link: "/hrtools/assets-management/inventory" },
      { id: 4, title: "Asset  Assignment", link: "/hrtools/assets-management/asset-assignment" },
    ],
    path: "/hrtools/assets-management",
    icon: <TbSettingsPlus />,
  },
  {
    id: 7,
    title: "E-Exit/Off-Boarding",
    path: "/hrtools/e-exit/Offboarding",
    // subLinks: [{ id: 1, title: "Full & Final Process", link: "/hrtools/e-exit/f&f-process" }],
    icon: <MdOutlineExitToApp />,
  },
];

export const subHeaderMenu = [
  { path: "/hrtools/attendance-dashboard", title: "Attendance Tracking" },
  { path: "/hrtools", title: "HR Dashboard" },
  { path: "/", title: "Employee Dashboard" },
  { path: "/hrtools/attendance/attendance-markup", title: "Mark Attendance" },
  { path: "/hrtools/attendance/attendance-report", title: "Attendance Report" },
  { path: "/hrtools/attendance-tracking/leave-request", title: "Leave Request" },
  { path: "/hrtools/attendance/holiday-calendar", title: "Holiday Calendar" },
  { path: "/hrtools/manage-fund", title: "Manage Fund" },
  { path: "/hrtools/manage-fund/payroll", title: "Payroll" },
  { path: "/hrtools/manage-fund/edit-salary", title: "Approve Salary" },
  { path: "/hrtools/generate-documents/employee-details", title: "Generate Documents" },
  { path: "/hrtools/manage-fund/advance-salary", title: "Advance Salary" },
  { path: "/hrtools/employee-onboarding/", title: "Employee Onboarding" },
  { path: "/hrtools/employee-profile", title: "Employee Profile" },
  { path: "/hrtools/assets-management", title: "Assets Management" },
  { path: "/hrtools/assets-management/add-asset", title: "Add Asset" },
  { path: "/hrtools/assets-management/pending-asset-verification", title: "Pending Asset Verification" },
  { path: "/hrtools/assets-management/inventory", title: "Inventory" },
  { path: "/hrtools/assets-management/asset-assignment", title: "Asset Assignment" },
  { path: "/hrtools/generate-documents", title: "Generate Documents" },
  { path: "/hrtools/e-exit/Offboarding", title: "E-exit" },
  { path: "/hrtools/e-exit/f&f-process", title: "Full & Final Process" },
  { path: "/hrtools/attendance/holidayform", title: "Add Holidays" },
  { path: "/hrtools/attendance/holiday-list-calendar/", title: "Holidays Calendar" },
];
